import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { Main } from '@components/Main';
import { PageContent } from '@components/PageContent';
import { PageTitle, PageTitleText } from '@components/PageTitle';
import { TableWrapper } from '@components/Table/TableWrapper';
import { useData } from '@hooks/useData';
import { useEffectOnce } from '@hooks/useEffectOnce';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import { useMenu } from '@hooks/useMenu';
import useMessage from '@hooks/useMessage';
import { EnumSortDirection } from '@hooks/useRequest';
import { EnumEmpresa, useEmpresaCombo } from '@model/Empresa';
import { IRemessa } from '@model/Remessa';
import { EnumRemessaStatus, useRemessaStatusCombo } from '@model/RemessaStatus';
import { IRemessaFilter, useRemessaService } from '@services/RemessaService';
import React from 'react';
import { RemessaFilter } from './RemessaFilter';
import { RemessaMenu } from './RemessaMenu';
import { RemessaTable } from './RemessaTable';

export type RemessaProps = {

}

export function Remessa (props: RemessaProps) {
    const loading = useLoading();
    const message = useMessage();

    const remessaService = useRemessaService();
    const empresaCombo = useEmpresaCombo();
    const remessaStatusCombo = useRemessaStatusCombo();
    const menu = useMenu();

    const data = useData<IRemessa, IRemessaFilter>({
        filter: {
            empresaId: useField(EnumEmpresa.None),
            competencia: useField(),
            descricao: useField(),
            remessaStatusId: useField(EnumRemessaStatus.None)
        },

        sortField: {
            name: "remessaId",
            direction: EnumSortDirection.Desc
        }
    });

    React.useEffect(() => {
        if (!loading.isLoading) {
            loading.start();
            remessaService.listar(data.requestedData)
                .then(data.handleResultResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData]);

    useEffectOnce(() => {
        empresaCombo.loadOptions();
        remessaStatusCombo.loadOptions();
    })

    return (
        <Main>
            <PageTitle>
                <HorizontalGrid>
                    <GridItem>
                        <PageTitleText text="Remessas" />
                    </GridItem>
                </HorizontalGrid>
            </PageTitle>
            
            <PageContent>
                <RemessaFilter 
                    filter={data.filter}
                    isLoading={loading.isLoading}
                    empresaCombo={empresaCombo}
                    remessaStatusCombo={remessaStatusCombo}
                />

                <TableWrapper>
                    <RemessaTable 
                        data={data}
                        isLoading={loading.isLoading}
                        menu={menu}
                    />
                </TableWrapper>

                {
                    data.focusedRow !== undefined && (
                        <React.Fragment>
                            <RemessaMenu 
                                remessa={data.focusedRow}
                                menu={menu}
                            />
                        </React.Fragment>
                    )
                }
            </PageContent>
        </Main>
    )
}